import { render } from "./StudentPanel.vue?vue&type=template&id=4687f3cd&scoped=true"
import script from "./StudentPanel.vue?vue&type=script&lang=js"
export * from "./StudentPanel.vue?vue&type=script&lang=js"

import "./StudentPanel.vue?vue&type=style&index=0&id=4687f3cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4687f3cd"]])

export default __exports__